import styled from 'styled-components';
import { colors } from '@/theme/colors';
import { fonts } from '@/theme/fonts';
import { ORDER_SORT_TYPE } from '@/api/type/commonTypes';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface ListSortsProps {
  handleSortClick: (type: ORDER_SORT_TYPE) => () => void;
  orderListPage?: boolean;
  count: number;
  countName: string;
}
const ListSorts = ({
  handleSortClick,
  orderListPage = false,
  count,
  countName,
}: ListSortsProps) => {
  const [searchParams] = useSearchParams();
  const sort = searchParams.get('sort');
  const { t } = useTranslation();

  return (
    <Container>
      <FilterGroup>
        <Count>Total: {`${count} ${countName}`}</Count>
        <FilterButtonSection>
          <StatusSortGroup>
            <Label>Sort</Label>
            <ButtonWrap>
              {orderListPage && (
                <SortButton
                  onClick={handleSortClick('PENDING')}
                  data-selected={sort === 'PENDING'}
                >
                  {t('pending2')}
                </SortButton>
              )}
              <SortButton
                onClick={handleSortClick('ORDER_DATE_DESC')}
                data-selected={sort === 'ORDER_DATE_DESC' || sort === null}
              >
                {t('orderDate')}
              </SortButton>
              <SortButton
                onClick={handleSortClick('DUE_DATE_DESC')}
                data-selected={sort === 'DUE_DATE_DESC'}
              >
                {t('dueDate')}
              </SortButton>
            </ButtonWrap>
          </StatusSortGroup>
        </FilterButtonSection>
      </FilterGroup>
    </Container>
  );
};

export default ListSorts;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 30px;
`;

const Count = styled.div`
  padding-left: 18px;
  font-family: ${fonts.family.poppins};
  font-size: 14px;
  line-height: 120%;
  color: #6a96f8;
  text-align: start;
`;

const FilterGroup = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 10px;
  font-size: 12px;
  width: 100%;
`;

const FilterButtonSection = styled.div`
  flex: 1;
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 10px;
`;

const PageSizeSelect = styled.select`
  width: 100px;
  display: block;
  padding: 5px;
  border: 1px solid ${colors.divider};
  border-radius: 5px;
  background: ${colors.white};
  color: ${colors.black};
`;

const StatusSortGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 9.8px;
  flex-wrap: wrap;
`;

const Label = styled.div`
  font-family: ${fonts.family.poppins};
  font-size: 14px;
  line-height: 120%;
  color: #6a96f8;
`;

const ButtonWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  flex-wrap: wrap;
`;

const SortButton = styled.button`
  padding: 0 20.7px;
  height: 23px;
  box-sizing: border-box;
  border-radius: 99px;
  font-size: 12px;
  line-height: 140%;
  color: #fffbfb;
  background: #c6c2c2;
  &[data-selected='true'] {
    background: #769bf7;
  }
  &[data-selected='false']:hover {
    background: rgba(118, 155, 247, 0.5);
  }
`;
